var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIlmor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20312 2.13281C5.99219 1.92188 5.99219 1.54688 6.20312 1.33594L6.60156 0.9375C6.8125 0.726562 7.1875 0.726562 7.39844 0.9375L10.5625 4.125C10.7969 4.33594 10.7969 4.6875 10.5625 4.89844L7.39844 8.08594C7.1875 8.29688 6.8125 8.29688 6.60156 8.08594L6.20312 7.6875C5.99219 7.47656 5.99219 7.10156 6.20312 6.89062L7.75 5.34375H0.8125C0.484375 5.34375 0.25 5.10938 0.25 4.78125V4.21875C0.25 3.91406 0.484375 3.65625 0.8125 3.65625H7.75L6.20312 2.13281Z",
    fill: "#07080C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIlmor);
export default __webpack_public_path__ + "static/media/arrowIlmor.6356366e93553591af7d80b7163b8747.svg";
export { ForwardRef as ReactComponent };